/**
 * string to display when the value of a cell is undefined or null
 */
export const NO_VALUE = "\u2014";
